export enum FlowTypes {
    Both = "both",
    Email = "email",
    Friends = "friends",
    Calisthenics = "calisthenics",
    Offer = "offer",
    HighIntent = "highIntent",
    CreoTests = "creoTests",
    Seniors = "seniors",
    Pilates = "pilates",
    Mex = "mex",
    FunnelFox = "funnelFox",
    WithoutAI = "WithoutAI",
    BodyScan = "bodyScan",
    BodyScanAbs = "bodyScanAbs",
    BodyScanPlans = "bodyScanPlans",
    FreeTrial = "freeTrial",
    WeightLoss = "weightLoss",
    PromoCode = "promoCode",
}
